import { render, staticRenderFns } from "./GroupWatchlist.vue?vue&type=template&id=65149f2c&"
import script from "./GroupWatchlist.vue?vue&type=script&lang=js&"
export * from "./GroupWatchlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports